
<template>

<basicContainer>
    <avue-form-design ref="avueformdesign"
        :options="options">
     </avue-form-design>
</basicContainer>

</template>

<script>
export default {

  data() {
    return {
      options: {}
    }
  },
  created() {
    if (this.$route.params.options) {
      this.options = this.$route.params.options
    } else {
      this.$message.error('缺失options参数,请联系管理员')
      this.$router.push({ path: '/500' })
    }
  },

  components: { AvueFormDesign: () => import('@/workFlow/formComponent/formDesigner/packages/index.vue') },

  methods: {

  }
}
</script>
<style lang="scss">
.widget-form-item {
  display: flex!important;
  flex-flow:row wrap;
  .el-form-item__content {
    margin-left: 0!important;
    flex: 1;
  }
}
.widget-form-group__item {
  display: flex!important;
  flex-flow:row wrap;
  .el-form-item__content {
    margin-left: 0!important;
    flex: 1;
  }
}
</style>
